import React from 'react';
import { About } from "../components/About";

export function AboutPage() {
    return (
        <div>
            <About/>
        </div>
    )
}
